import { usePopover } from '@deltasierra/react-hooks';
import MoreVert from '@material-ui/icons/MoreVert';
import * as React from 'react';
import { DSClickAwayListener, DSGrow, DSMenuList, DSPaper, DSPopper } from '../../mui';
import { DSIconButton } from '../Buttons';

export type ActionButtonProps = {
    ariaLabel?: string;
    children: React.ReactNode;
    dataCy?: string;
    keepOpen?: boolean;
};

export function ActionButton({ ariaLabel = '', children, dataCy, keepOpen = false }: ActionButtonProps): JSX.Element {
    const [element, isOpen, { handleClose, handleListKeyDown, handleToggle }] = usePopover();

    const open = isOpen || keepOpen;
    return (
        <>
            <DSIconButton
                aria-controls={isOpen ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                aria-label={ariaLabel}
                color="primary"
                data-cy={dataCy}
                size="small"
                onClick={handleToggle}
            >
                <MoreVert color="primary" />
            </DSIconButton>
            <DSPopper anchorEl={element} disablePortal open={open} role={undefined} style={{ zIndex: 1 }} transition>
                {({ placement, TransitionProps }) => (
                    <DSGrow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <DSPaper>
                            <DSClickAwayListener onClickAway={handleClose}>
                                <DSMenuList
                                    autoFocusItem={isOpen}
                                    id="menu-list-grow"
                                    onClick={handleClose}
                                    onKeyDown={handleListKeyDown}
                                >
                                    {children}
                                </DSMenuList>
                            </DSClickAwayListener>
                        </DSPaper>
                    </DSGrow>
                )}
            </DSPopper>
        </>
    );
}
ActionButton.displayName = 'ActionButton';
